var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitEntryIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.037,
    height: 78.213,
    viewBox: "0 0 59.037 78.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recruit_entry_icon9",
    transform: "translate(-92.563 -740)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184024",
    "data-name": "\\uADF8\\uB8F9 184024",
    transform: "translate(111.707 750.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131794",
    "data-name": "\\uD328\\uC2A4 131794",
    d: "M388.752,198.241l19.836,11.052V186l-19.836-11.051Z",
    transform: "translate(-388.152 -174.348)",
    fill: "#ffbf17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131795",
    "data-name": "\\uD328\\uC2A4 131795",
    d: "M408.88,185.474l-19.838-11.052a.61.61,0,0,0-.594.007.6.6,0,0,0-.3.518v23.294a.6.6,0,0,0,.307.524L408.3,209.818a.622.622,0,0,0,.292.075.611.611,0,0,0,.3-.082.6.6,0,0,0,.3-.519V186A.6.6,0,0,0,408.88,185.474Zm-.891,22.8-18.637-10.383V175.969l18.637,10.383Z",
    transform: "translate(-388.152 -174.348)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184025",
    "data-name": "\\uADF8\\uB8F9 184025",
    transform: "translate(111.074 739.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131796",
    "data-name": "\\uD328\\uC2A4 131796",
    d: "M388.752,174.973,408.7,186.045l18.11-10.148-19.954-11.072Z",
    transform: "translate(-387.519 -164.138)",
    fill: "#ffa8d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131797",
    "data-name": "\\uD328\\uC2A4 131797",
    d: "M387.519,174.976l21.187,11.756,19.339-10.838L406.86,164.138Zm38.063.923L408.7,185.358l-18.721-10.387,16.88-9.46Z",
    transform: "translate(-387.519 -164.138)",
    fill: "#32303c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184026",
    "data-name": "\\uADF8\\uB8F9 184026",
    transform: "translate(131.913 751.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131798",
    "data-name": "\\uD328\\uC2A4 131798",
    d: "M408.958,209.457l17.857-9.527V175.9l-17.857,10.033Z",
    transform: "translate(-408.358 -175.296)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131799",
    "data-name": "\\uD328\\uC2A4 131799",
    d: "M426.519,175.374l-17.855,10.032a.6.6,0,0,0-.306.524v23.527a.6.6,0,0,0,.882.529l17.856-9.527a.6.6,0,0,0,.318-.53V175.9a.6.6,0,0,0-.895-.522Zm-.306,24.2-16.655,8.886V186.281l16.655-9.359Z",
    transform: "translate(-408.358 -175.296)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184037",
    "data-name": "\\uADF8\\uB8F9 184037",
    transform: "translate(92.563 772.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184034",
    "data-name": "\\uADF8\\uB8F9 184034",
    transform: "translate(0.631 10.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131809",
    "data-name": "\\uD328\\uC2A4 131809",
    d: "M370.239,230.534l19.838,11.053V218.292l-19.838-11.051Z",
    transform: "translate(-369.639 -206.641)",
    fill: "#00ddb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131810",
    "data-name": "\\uD328\\uC2A4 131810",
    d: "M390.367,217.768l-19.835-11.051a.6.6,0,0,0-.893.525v23.292a.6.6,0,0,0,.31.525l19.835,11.052a.6.6,0,0,0,.892-.524V218.292A.6.6,0,0,0,390.367,217.768Zm-.891,22.8-18.637-10.382v-21.92l18.637,10.382Z",
    transform: "translate(-369.639 -206.641)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184035",
    "data-name": "\\uADF8\\uB8F9 184035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131811",
    "data-name": "\\uD328\\uC2A4 131811",
    d: "M370.239,207.268l19.954,11.072L408.3,208.191l-19.952-11.072Z",
    transform: "translate(-369.008 -196.433)",
    fill: "#ffa8d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131812",
    "data-name": "\\uD328\\uC2A4 131812",
    d: "M369.008,207.27l21.186,11.756,19.339-10.837-21.186-11.756Zm38.062.923-16.879,9.46-18.719-10.388,16.877-9.459Z",
    transform: "translate(-369.008 -196.433)",
    fill: "#32303c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184036",
    "data-name": "\\uADF8\\uB8F9 184036",
    transform: "translate(20.837 11.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131813",
    "data-name": "\\uD328\\uC2A4 131813",
    d: "M390.446,241.751l17.855-9.527V208.191l-17.855,10.033Z",
    transform: "translate(-389.845 -207.59)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131814",
    "data-name": "\\uD328\\uC2A4 131814",
    d: "M408.007,207.667,390.152,217.7a.6.6,0,0,0-.307.524v23.527a.6.6,0,0,0,.292.515.6.6,0,0,0,.309.085.6.6,0,0,0,.282-.07l17.855-9.528a.6.6,0,0,0,.319-.529V208.191a.6.6,0,0,0-.9-.524Zm-.3,24.2-16.657,8.887V218.574l16.657-9.359Z",
    transform: "translate(-389.845 -207.59)",
    fill: "#111"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitEntryIcon9);
export default __webpack_public_path__ + "static/media/recruit_entry_icon9.cd3f58e8b785bdecd503b33a918a8a6f.svg";
export { ForwardRef as ReactComponent };